import * as config from "../config";
import requestUtil, { RequestMethod, RequestOptions } from "../utils/requestUtil";

export default class Base {
  baseUrl: string = `${config.apiBaseUrl}`;

  async get(route: string, options?: RequestOptions) {
    return await this.call(route, "Get", undefined, options);
  }

  async post(route: string, data?: any, options?: RequestOptions) {
    return await this.call(route, "Post", data, options);
  }

  async patch(route: string, data?: any, options?: RequestOptions) {
    return await this.call(route, "Patch", data, options);
  }

  async put(route: string, data?: any) {
    return await this.call(route, "Put", data);
  }

  async delete(route: string, data?: any) {
    return await this.call(route, "Delete", data);
  }

  async call(route: string, method: RequestMethod, data?: any, options: RequestOptions = {}) {
    try {
      const url = `${this.baseUrl}${route}`;
      return await requestUtil.call(url, method, data, options);
    } catch (err) {
      throw err;
    }
  }
}